import { ScrollReveal, SectionLabel } from "./Reveal";

const audiences = [
  "Restaurants", "Gyms", "Hotels", "Barbers", "Clothing Brands",
  "Car Dealerships", "Real Estate", "Events", "Personal Brands", "Sports Orgs",
];

export const WhoIWorkWithSection = () => (
  <section data-testid="who-i-work-with-section" className="py-24 lg:py-32 bg-[#111111] border-y border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <ScrollReveal>
        <SectionLabel index="06" title="Who I Work With" />
      </ScrollReveal>

      <div className="mt-10 flex flex-wrap gap-3" data-testid="audience-list">
        {audiences.map((a, i) => (
          <ScrollReveal key={a} delay={i * 0.04}>
            <span
              data-testid={`audience-tag-${a.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-block font-display text-lg sm:text-xl lg:text-2xl border border-white/15 px-6 py-3 hover:bg-[#F2F0EB] hover:text-[#0A0A0A] hover:border-[#F2F0EB] transition-colors duration-300 cursor-default"
            >
              {a}
            </span>
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal delay={0.2}>
        <h3 className="mt-20 font-display leading-[0.95] text-[8vw] sm:text-[6vw] lg:text-[4.5vw] max-w-5xl" data-testid="who-statement">
          If you've got something worth building, <span className="text-outline">I've got something worth filming.</span>
        </h3>
      </ScrollReveal>
    </div>
  </section>
);
